import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../lib/api";
import { ArrowRight } from "lucide-react";

export default function CitiesByState() {
  const { code } = useParams();
  const [cities, setCities] = useState([]);

  useEffect(() => {
    api.get(`/cities/by-state/${code}`).then(r => setCities(r.data));
  }, [code]);

  const stateName = cities[0]?.state || code;

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="cities-by-state">
      <Link to="/cities" className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706] hover:underline">← Back to coverage map</Link>
      <h1 className="display-black text-5xl lg:text-6xl uppercase text-[#064E3B] mt-4 tracking-tighter">{stateName}</h1>
      <p className="text-gray-700 mt-2">{cities.length} cities served · Available Junk Removal network</p>

      <div className="mt-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-gray-300 border border-gray-300">
        {cities.map(c => (
          <Link key={c.id} to={`/city/${c.slug}`} className="bento-card p-5 flex items-center justify-between" data-testid={`state-city-${c.slug}`}>
            <div>
              <div className="font-bold text-sm text-[#064E3B]">{c.name}</div>
              <div className="mono text-[10px] tracking-wider text-gray-500 uppercase">pop. {c.population.toLocaleString()}</div>
            </div>
            <ArrowRight className="w-4 h-4 text-gray-400" />
          </Link>
        ))}
      </div>
    </div>
  );
}
